import { ZUid, zUid } from "src/types/zUid";
import { z } from "zod";

const zAuditEntityAttAction = z.enum(["add", "edit", "delete"]);
export type ZAuditEntityAttAction = z.infer<typeof zAuditEntityAttAction>;

export const zAuditEntityAtt = z.object({
  id: zUid,
  name: z.string(),
  value: z.string().nullable(),
  valueType: z.number(),
  action: zAuditEntityAttAction,
});
export type ZAuditEntityAtt = z.infer<typeof zAuditEntityAtt>;

export const zAuditEntityValue = z.object({
  userId: zUid,
  fio: z.string().nullable(),
  email: z.string().nullable(),
  timestamp: z.string(),
  attributes: zAuditEntityAtt.array(),
});
export type ZAuditEntityValue = z.infer<typeof zAuditEntityValue>;

export type AuditEntityValueFilters = {
  entityId: ZUid;
  timestamp?: string[];
  userId?: ZUid;
  attributeId?: ZUid;
};

export const zAuditEntityValueResponse = z.object({
  totalElements: z.number(),
  content: zAuditEntityValue.array(),
});
